import React from 'react';
import PageBack from '@/components/pageback';
import usePageBack from '@/utils/usePageBack';
import './index.scss';

const StandaloneBack = ({ fallback = '/', disabled = false, withHeader = false }) => {
  const goBack = usePageBack(fallback);
  return <PageBack className={`standaloneBack${withHeader ? ' standaloneBack-withHeader' : ''}`} onBack={goBack} disabled={disabled} />;
};

export default StandaloneBack;
